import { render, staticRenderFns } from "./AcceptLogs.vue?vue&type=template&id=8957722c&"
import script from "./AcceptLogs.vue?vue&type=script&lang=js&"
export * from "./AcceptLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports